import React from 'react';

import _ from 'lodash';
import cx from 'classnames';

import styles from './anchor.module.scss';

const AnchorWidget = React.memo(function AnchorWidget({ className, style, widgetProps, widgetRef }) {
  const ref = widgetRef;
  const id = _.get(widgetProps, 'uid');

  return (
    <div
      id={id}
      ref={ref}
      className={cx(className, styles.anchorWidget)}
      style={style}
      data-widget-id={id}
    >
    </div>
  )
});

export { AnchorWidget };
